import "./SearchBar.scss";

import get from "lodash/get";
import React, { useState } from "react";
import { useNavigate } from "react-router-dom";

import { ReactComponent as SearchIcon } from "../assets/icons/search.svg";
import { searchProperties } from "../services/api";
import { isRunningInFront } from "../services/front";
import Button from "./Button";
import User from "./User";

const SearchBar = () => {
  const [searchInput, setSearchInput] = useState("");
  const navigate = useNavigate();

  const handleOnChange = e => {
    setSearchInput(e.target.value);
  };

  const handleEnter = e => {
    if (e.key === "Enter") {
      handleRedirect();
    }
  };

  const handleRedirect = () => {
    const homeCode = searchInput.replace(/\s+/g, "").toUpperCase();

    setSearchInput(homeCode);

    const showError = message => {
      return navigate("/not-found", {
        state: { error: message }
      });
    };

    searchProperties({ home_code: homeCode })
      .then(({ data }) => {
        const airbnbLogin = data.property.airbnb_login;

        navigate(`/mailbox/${airbnbLogin}`);
        setSearchInput("");
      })
      .catch(error => {
        const errorMessage = get(
          error,
          "response.data.error",
          "Please try again."
        );

        return showError(errorMessage);
      });
  };

  if (isRunningInFront) {
    return null;
  }

  return (
    <div className="SearchBar">
      <div className="SearchBar__search">
        <input
          placeholder={"Search by home code"}
          onKeyPress={handleEnter}
          onChange={handleOnChange}
          value={searchInput}
        />

        <Button
          buttonType="positive"
          handleOnClick={handleRedirect}
          disabled={!searchInput}
          className="iconOnly"
        >
          <SearchIcon />
        </Button>
      </div>

      <User />
    </div>
  );
};

export default SearchBar;
